<form class="" [formGroup]="dateForm">
    <mat-form-field appearance="outline">
      <mat-label>{{ label | translate }}</mat-label>
      <input matInput (dateChange)="onDateSelect($event)" [matDatepicker]="startDate" readonly (click)="startDate.open()" [min]="minDate" [max]="maxDate" formControlName="dateSelected"/>
      <div class="d-flex align-items-center" matIconSuffix>
        <mat-datepicker-toggle  [for]="startDate"></mat-datepicker-toggle>
        <button class="clear-btn" aria-label="Clear" *ngIf="dateForm.get('dateSelected')?.value" (click)="reset(); $event.stopPropagation()">
          <lucide-icon name="X" size="16"></lucide-icon>
        </button>
      </div>
      <mat-datepicker #startDate></mat-datepicker>
      <mat-error *ngIf="dateForm.get('dateSelected')?.errors?.['required']">{{ 'Common.requiredField' | translate }}</mat-error>
  </mat-form-field>
</form>